// @ts-nocheck

import * as R from 'ramda';
import { READ_PERMISSION, TEAM_ACCESS, WRITE_PERMISSION } from '../../common/support/accessControlConstants';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
const UserPermissions = new ReduxAsyncAction('USER_PERMISSIONS');
UserPermissions.registerRequest(function (isAgencyUser, isAgencyView) {
  return dash_api.get('/v1/dashboard-user/permissions').then(({ data }) => {
    // check if the agency user is not on agency dashboard and has write permission
    // and step down the permission to read only
    const stepDownAgencyTeamAccess =
      isAgencyUser && !isAgencyView && R.path([TEAM_ACCESS, 'permission'], data) === WRITE_PERMISSION;

    if (stepDownAgencyTeamAccess) {
      const dataPermission = R.clone(data);
      dataPermission[TEAM_ACCESS] = R.assoc('permission', READ_PERMISSION, R.path([TEAM_ACCESS], dataPermission));
      return dataPermission;
    }

    return data;
  });
});
export const getUserPermissions = UserPermissions.request;
export const USER_PERMISSIONS = UserPermissions.constants;
const DefaultRoles = new ReduxAsyncAction('DEFAULT_ROLES');
DefaultRoles.registerRequest(function () {
  return dash_api.get('/v1/access-control/default-roles').then(({ data }) => {
    const rolePermissions = data.reduce((roles, rule) => {
      const roleIdConfig = roles[rule.access_role_id] ? { ...roles[rule.access_role_id] } : {};
      roleIdConfig[rule.name] = rule.permission;
      roles[rule.access_role_id] = roleIdConfig;
      return roles;
    }, {});
    const roleFilters = data.reduce((roles, rule) => {
      const roleIdConfig = roles[rule.access_role_id] ? { ...roles[rule.access_role_id] } : {};
      roleIdConfig[rule.name] = rule.access_filter;
      roles[rule.access_role_id] = roleIdConfig;
      return roles;
    }, {});
    return {
      rolePermissions,
      roleFilters,
    };
  });
});
export const getDefaultRoles = DefaultRoles.request;
export const DEFAULT_ROLES = DefaultRoles.constants;
const AppDefaultRoles = new ReduxAsyncAction('APP_DEFAULT_ROLES');
AppDefaultRoles.registerRequest(async function () {
  const response = await dash_api.get('/v1/access-control/app-roles');
  return (response?.data || []).reduce((acc, role) => ({ ...acc, [role.id]: role.name }), {});
});
export const getAppDefaultRoles = AppDefaultRoles.request;
export const APP_DEFAULT_ROLES = AppDefaultRoles.constants;
